/**
 * Mobile nav Safari scroll rescue
 * - Syncs is-mobile-nav-open class from drawer .open state
 * - Undoes body-scroll-lock's body { position: fixed } which breaks iOS drawer scroll
 * - Ignores touchmove preventDefault for touches inside the drawer
 */
(function () {
  function boot() {
    var nav = document.querySelector('[data-mobile-navigation]');
    if (!nav) return;

    var sync = function () {
      var open = nav.classList.contains('open');
      document.documentElement.classList.toggle('is-mobile-nav-open', open);
      document.body.classList.toggle('is-mobile-nav-open', open);

      if (open && document.body.style.position === 'fixed') {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
      }
    };

    new MutationObserver(sync).observe(nav, {
      attributes: true,
      attributeFilter: ['class']
    });
    sync();

    var originalPreventDefault = Event.prototype.preventDefault;
    Event.prototype.preventDefault = function () {
      if (
        this.type === 'touchmove' &&
        document.documentElement.classList.contains('is-mobile-nav-open') &&
        this.target &&
        typeof this.target.closest === 'function' &&
        this.target.closest('[data-mobile-navigation]')
      ) {
        return;
      }
      return originalPreventDefault.apply(this, arguments);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
